import { render, staticRenderFns } from "./colors.vue?vue&type=template&id=51d2d5a1&scoped=true"
import script from "./colors.vue?vue&type=script&lang=js"
export * from "./colors.vue?vue&type=script&lang=js"
import style0 from "./colors.vue?vue&type=style&index=0&id=51d2d5a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2d5a1",
  null
  
)

export default component.exports